"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_DICTATE_STATE = void 0;
exports["default"] = setDictateState;
var SET_DICTATE_STATE = 'WEB_CHAT/SET_DICTATE_STATE';
exports.SET_DICTATE_STATE = SET_DICTATE_STATE;

function setDictateState(dictateState) {
  return {
    type: SET_DICTATE_STATE,
    payload: {
      dictateState: dictateState
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfRElDVEFURV9TVEFURSIsInNldERpY3RhdGVTdGF0ZSIsImRpY3RhdGVTdGF0ZSIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2V0RGljdGF0ZVN0YXRlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFVF9ESUNUQVRFX1NUQVRFID0gJ1dFQl9DSEFUL1NFVF9ESUNUQVRFX1NUQVRFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0RGljdGF0ZVN0YXRlKGRpY3RhdGVTdGF0ZSkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFVF9ESUNUQVRFX1NUQVRFLFxuICAgIHBheWxvYWQ6IHsgZGljdGF0ZVN0YXRlIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VUX0RJQ1RBVEVfU1RBVEUgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGlCQUFpQixHQUFHLDRCQUExQjs7O0FBRWUsU0FBU0MsZUFBVCxDQUF5QkMsWUFBekIsRUFBdUM7RUFDcEQsT0FBTztJQUNMQyxJQUFJLEVBQUVILGlCQUREO0lBRUxJLE9BQU8sRUFBRTtNQUFFRixZQUFZLEVBQVpBO0lBQUY7RUFGSixDQUFQO0FBSUQifQ==